import React from 'react'
import PropTypes from 'prop-types'
import {
  FormInput,
  Margin,
  Text,
  Drawer,
  FormListItem,
  Form,
  Panel,
  Button,
} from 'shared/components'
import { observer } from 'mobx-react'
import { Label } from 'shared/components/newInput/Label'

import * as styles from './styles'

const BeneficiaryPersonalFormComponent = ({
  form,
  onSubmit,
  appConfig,
  isLoading,
  getOptionLabel,
  getOptionValue,
  loadJurisdictions,
}) => (
  <>
    <FormListItem
      title="Personal information"
      description="Update your personal information"
      onClick={() => appConfig.toggleDrawer('personalInfo-Beneficiary')}
    />
    <Drawer
      isActive={appConfig.drawerState === 'personalInfo-Beneficiary'}
      hideDrawer={() => appConfig.toggleDrawer('')}
    >
      {appConfig.drawerState === 'personalInfo-Beneficiary' && (
        <Panel
          as={Form}
          form={form}
          onSubmit={onSubmit}
          css={styles.formWrapper}
        >
          {/* Add form content here as needed for beneficiary */}
        </Panel>
      )}
    </Drawer>
  </>
)

BeneficiaryPersonalFormComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  onSubmit: PropTypes.func.isRequired,
  getOptionLabel: PropTypes.func.isRequired,
  getOptionValue: PropTypes.func.isRequired,
  loadJurisdictions: PropTypes.func.isRequired,
  appConfig: PropTypes.shape(),
  isLoading: PropTypes.bool,
}

export default observer(BeneficiaryPersonalFormComponent)
